import React from 'react';
import { MarketingLayout } from '@byscott-io/corebyscott';

export default function AboutPage() {
  return (
    <MarketingLayout>
      <div className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8 text-center">
            About RecipesByScott
          </h1>

          <div className="prose dark:prose-invert max-w-none">
            <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
              RecipesByScott is a simple, focused recipe management app built for families who want to
              organize their recipes, plan meals, and streamline their grocery shopping.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-8 mb-4">
              Why We Built This
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Tired of scattered recipes across bookmarks, notes apps, and physical cookbooks? We built
              RecipesByScott to bring everything together in one place that the whole family can access.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-8 mb-4">
              Part of IdeasByScott
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              RecipesByScott is part of the IdeasByScott suite of practical tools. We build software
              that solves real problems for real people, without unnecessary complexity.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-8 mb-4">
              Privacy First
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              Your recipes are yours. We don't sell your data or show you ads. You control what's
              private and what's shared publicly.
            </p>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}
